export const directBookingsSettingsView = {
  loading: "Loading settings…",

  sidebar: {
    brandTitle: "Listings",
    brandSub: "Settings panel",
    searchPlaceholder: "Search…",
    generalLabel: "General",
    servicesName: "Services and experiences",
    servicesSub: "One list for the whole account",
    promotionsName: "Promotions",
    promotionsSub: "Create · Edit · Manage",
    globalChip: "GLOBAL",
    inactivePrefix: "Inactive · {type}",
    unitsCount: "{count} unit | {count} units",
    empty: "No properties.",
    listingFallbackName: "Listing",
  },

  status: {
    active: "Active",
    inactive: "Inactive",
  },

  card: {
    unsavedChanges: "Unsaved changes",
  },

  share: {
    title: "Direct booking link",
    hintPrefix: "Share the link for",
    hintSuffix: "to take commission-free bookings.",
    copyTitle: "Copy link",
    viewAsVisitor: "View as visitor",
    copied: "Link copied.",
    copyError: "Couldn't copy the link.",
    whatsappText: "Hi 👋 Here's the link to book: {link}",
  },

  savebar: {
    unsaved: "Unsaved changes",
    noChanges: "No pending changes",
    saving: "Saving…",
  },

  drawer: {
    close: "Close",
  },

  content: {
    selectListing: "Select a listing",
  },

  units: {
    pickerHint: "Turn each unit's visibility on or off for direct bookings, or open it to set it up (rates, images, description, services and charges).",
    visible: "Visible",
    hidden: "Hidden",
    showTooltip: "Show this unit in direct bookings",
    configure: "Configure",
  },

  header: {
    listingSub: "Listing · {count} unit · direct bookings | Listing · {count} units · direct bookings",
    unitSub: "Unit · individual setup",
    unitSubCoded: "Unit {code} · individual setup",
    hotelSub: "Hotel / Campsite · direct bookings",
    apartmentSub: "Apartment / Villa · direct bookings",
  },

  tabs: {
    reservations:       { label: "Listing visibility",  sub: "Turn it on and set payment and approval for direct bookings" },
    units_list:         { label: "Units",               sub: "Which units can be booked" },
    common_images:      { label: "Common areas",        sub: "Shared building photos (cover)" },
    rate_plans:         { label: "Rates",               sub: "Visible rate plans" },
    images:             { label: "Images",              sub: "Listing gallery" },
    description:        { label: "Description",          sub: "Listing text and details" },
    services:           { label: "Services",            sub: "Services and amenities" },
    promotions:         { label: "Promotions",          sub: "How they show on this listing" },
    addons:             { label: "Occupancy",           sub: "Discounts and extra guest" },
    age_rules:          { label: "Guest rules",         sub: "Infants, children and capacity" },
    additional_charges: { label: "Charges and taxes",   sub: "VAT, cleaning and charges" },
    web_embed:          { label: "Web integration",     sub: "Add the search box to your own site" },
  },

  save: {
    ratePlans: "Save rates",
    promotions: "Save promotions",
    addons: "Save charges",
    ageRules: "Save rules",
    additionalCharges: "Save charges and taxes",
    payments: "Save payments",
    default: "Save",
  },

  types: {
    apartment: "Apartment",
    house: "House",
    villa: "Villa",
    loft: "Loft",
    room: "Room",
    studio: "Studio",
    cabin: "Cabin",
    hotel: "Hotel",
    hostel: "Hostel",
    camping: "Campsite",
  },

  toasts: {
    unitVisible: "Unit visible in direct bookings.",
    unitHidden: "Unit hidden.",
    unitUpdateError: "Couldn't update the unit.",
  },

  errors: {
    noUserUuid: "User UUID not found.",
    loadPage: "Couldn't load the page.",
    loadContext: "Couldn't load the context.",
    saveExec: "Couldn't run the save.",
    saveGeneric: "Couldn't save.",
  },

  misc: {
    propertyFallback: "Property {id}",
  },
};
